<template>
  <div>
    <v-toolbar dense
               src="https://www.cellmark.com/wp-content/uploads/2019/09/printing-and-writing-papers.jpg"
    >
      <v-spacer></v-spacer>
      <v-dialog
        v-model="dialog"
        width="800"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="blue"
            v-bind="attrs"
            v-on="on"
            outlined
            class="black--text"
          >
            Vytvořit dobropis
          </v-btn>
        </template>
        <CreateCreditNoteForm
          @data-saved="dialog = false; initialize()"
          v-if="dialog"
        ></CreateCreditNoteForm>
      </v-dialog>
    </v-toolbar>
    <template>
      <v-card>
        <v-card-title>
          Dobropisy
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledat"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="creditNotes"
          :search="search"
          :loading="loading"
          :items-per-page="-1"
        >
          <template v-slot:item.show="{ item }">
            <v-icon
              @click="showInvoice(item)"
            >mdi-eye</v-icon>
          </template>
        </v-data-table>
        <v-dialog v-model="creditNoteDialog">
          <v-card>
            <CreditView
              v-if="creditNoteDialog" :credit-note="displayedCreditNote"
            ></CreditView>
          </v-card>
        </v-dialog>
      </v-card>
    </template>
  </div>
</template>

<script>
import CreditView from '../../components/CreditView'
import CreateCreditNoteForm from '@/components/forms/admin/CreateCreditNoteForm'
export default {
  name: 'CreditNote',
  components: { CreateCreditNoteForm, CreditView },
  data () {
    return {
      creditNotes: [],
      dialog: false,
      loading: false,
      creditNoteDialog: false,
      displayedCreditNote: null,
      search: null,
      headers: [
        { text: 'Číslo dobropisu', value: 'id', align: 'start', sortable: true },
        { text: 'Zákazník', value: 'userName' },
        { text: 'Vytvořen adminem', value: 'admin.email' },
        { text: 'Vytvořen datum', value: 'created' },
        { text: 'Částka', value: 'amount' },
        { text: 'Poznámka', value: 'comment' },
        { text: 'Zobrazit', value: 'show', sortable: false }
      ]
    }
  },
  methods: {
    initialize () {
      this.loading = true
      this.$http.get('/admin/transactions/credit-notes')
        .then(response => {
          this.creditNotes = this.keysToCamelCase(response.data)
            .map(note => {
              const c = new Date(note.createdAt)
              note.created = `${c.getDate()}.${c.getMonth() + 1}.${c.getFullYear()}
                ${c.getHours()}:${c.getMinutes()}:${c.getSeconds() < 10 ? '0' + c.getSeconds() : c.getSeconds()}`
              note.userName = `${note.user.firstName} ${note.user.lastName}`
              return note
            })
            .reverse()
        })
        .catch(err => { console.log(err) })
        .finally(() => {
          this.loading = false
        })
    },
    showInvoice (item) {
      this.displayedCreditNote = item
      this.creditNoteDialog = true
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>

</style>
